export default __webpack_public_path__ + "static/media/connection.80aefbae.jpg";